import { createContext, useContext } from "react";
import { ADD_FARM_CONTEXT_ACTION_TYPES } from "./add-farm-context-reducer";

export const AddFarmContext = createContext(null)
export const AddFarmContextDispatch = createContext(null)

export const useAddFarmContext = () => {
  return useContext(AddFarmContext)
}

export const useAddFarmContextDispatch = () => {
  return useContext(AddFarmContextDispatch)
}

// Dispatch Helpers

export const setName = (name) => {
  return {
    type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_NAME,
    name,
  }
}

export const setLat = (lat) => {
  return {
    type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_LAT,
    lat,
  }
}

export const setLng = (lng) => {
  return {
    type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_LNG,
    lng,
  }
}

export const setZoom = (zoom) => {
  return {
    type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_ZOOM,
    zoom,
  }
}

export const setBounds = (bounds) => {
  return {
    type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_BOUNDS,
    bounds,
  }
}

export const setZone = (zone) => {
  return {
    type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_ZONE,
    zone,
  }
}

export const setLfd = (lfd) => {
  return {
    type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_LFD,
    lfd,
  }
}

export const setFfd = (ffd) => {
  return {
    type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_FFD,
    ffd,
  }
}

export const setGdd5 = (gdd5) => {
  return {
    type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_GDD_5,
    gdd5,
  }
}

export const setGdd10 = (gdd10) => {
  return {
    type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_GDD_10,
    gdd10,
  }
}

export const setAbsMaxTemp = (absMaxTemp) => {
  return {
    type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_ABS_MAX_TEMP,
    absMaxTemp,
  }
}

export const setAbsMinTemp = (absMinTemp) => {
  return {
    type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_ABS_MIN_TEMP,
    absMinTemp,
  }
}

export const setAvgMaxTemp = (avgMaxTemp) => {
  return {
    type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_MAX_TEMP,
    avgMaxTemp,
  }
}

export const setAvgMinTemp = (avgMinTemp) => {
  return {
    type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_MIN_TEMP,
    avgMinTemp,
  }
}

export const setAvgDtr = (avgDtr) => {
  return { type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_DTR, avgDtr }
}

export const setAvgFfw = (avgFfw) => {
  return { type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_FFW, avgFfw }
}

export const setMinFfw = (minFfw) => {
  return { type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_MIN_FFW, minFfw }
}

export const setAvgOptimalDays = (avgOptimalDays) => {
  return { type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_OPTIMAL_DAYS, avgOptimalDays }
}

export const setAvgHeatDays32 = (avgHeatDays32) => {
  return { type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_HEAT_DAYS32, avgHeatDays32 }
}

export const setAvgHeatDays38 = (avgHeatDays38) => {
  return { type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_HEAT_DAYS38, avgHeatDays38 }
}

export const setAvgTropNights = (avgTropNights) => {
  return { type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_TROP_NIGHTS, avgTropNights }
}

export const setAvgChillDays = (avgChillDays) => {
  return { type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_CHILL_DAYS, avgChillDays }
}

export const setStdLfd = (stdLfd) => {
  return { type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_STD_LFD, stdLfd }
}

export const setStdFfd = (stdFfd) => {
  return { type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_STD_FFD, stdFfd }
}

export const setFsRisk = (fsRisk) => {
  return { type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_FS_RISK, fsRisk }
}

export const setAvgDailyGdd5 = (avgDailyGdd5) => {
  return { type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_DAILY_GDD5, avgDailyGdd5 }
}

export const setAvgDailyGdd10 = (avgDailyGdd10) => {
  return { type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_AVG_DAILY_GDD10, avgDailyGdd10 }
}

// Bulk climate data helpers — map raw climate atlas column names to context variables

export const setClimateDataFromHex = (hex) => {
  return {
    type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_CLIMATE_DATA,
    data: {
      lfd: hex.avg_lfd,
      ffd: hex.avg_ffd,
      gdd5: hex.avg_gdd5,
      gdd10: hex.avg_gdd10,
      avgMaxTemp: hex.avg_max_temp,
      avgMinTemp: hex.avg_min_temp,
      absMaxTemp: hex.abs_max_temp,
      absMinTemp: hex.abs_min_temp,
      avgDtr: hex.avg_dtr,
      avgFfw: hex.avg_ffw,
      minFfw: hex.min_ffw,
      avgOptimalDays: hex.avg_optimal_days,
      avgHeatDays32: hex.avg_heat_days32,
      avgHeatDays38: hex.avg_heat_days38,
      avgTropNights: hex.avg_trop_nights,
      avgChillDays: hex.avg_chill_days,
      stdLfd: hex.std_lfd,
      stdFfd: hex.std_ffd,
      fsRisk: hex.fs_risk,
      avgDailyGdd5: hex.avg_daily_gdd5,
      avgDailyGdd10: hex.avg_daily_gdd10,
      gdd5Series: hex.gdd5_series,
      gdd10Series: hex.gdd10_series,
    },
  }
}

export const setClimateDataFromInterpolated = (interpolated) => {
  return {
    type: ADD_FARM_CONTEXT_ACTION_TYPES.SET_CLIMATE_DATA,
    data: {
      lfd: interpolated.interpolated_lfd,
      ffd: interpolated.interpolated_ffd,
      gdd5: interpolated.interpolated_gdd5,
      gdd10: interpolated.interpolated_gdd10,
      avgMaxTemp: interpolated.interpolated_avg_max_temp,
      avgMinTemp: interpolated.interpolated_avg_min_temp,
      absMaxTemp: interpolated.interpolated_abs_max_temp,
      absMinTemp: interpolated.interpolated_abs_min_temp,
      avgDtr: interpolated.interpolated_avg_dtr,
      avgFfw: interpolated.interpolated_avg_ffw,
      minFfw: interpolated.interpolated_min_ffw,
      avgOptimalDays: interpolated.interpolated_avg_optimal_days,
      avgHeatDays32: interpolated.interpolated_avg_heat_days32,
      avgHeatDays38: interpolated.interpolated_avg_heat_days38,
      avgTropNights: interpolated.interpolated_avg_trop_nights,
      avgChillDays: interpolated.interpolated_avg_chill_days,
      stdLfd: interpolated.interpolated_std_lfd,
      stdFfd: interpolated.interpolated_std_ffd,
      fsRisk: interpolated.interpolated_fs_risk,
      avgDailyGdd5: interpolated.interpolated_avg_daily_gdd5,
      avgDailyGdd10: interpolated.interpolated_avg_daily_gdd10,
      gdd5Series: interpolated.interpolated_gdd5_series,
      gdd10Series: interpolated.interpolated_gdd10_series,
    },
  }
}

export const resetState = () => {
  return {
    type: ADD_FARM_CONTEXT_ACTION_TYPES.RESET_STATE,
  }
}
